import { Carousel, Divider } from 'antd';
import Link from 'next/link';
import { logCommonView } from '@/lib/service';
import { EventSource } from '@/shared/types/event-types';
import React, { useMemo } from 'react';
import { useConfigProvider } from '@/lib/context';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { imgix } from '@/shared/utils/utils';
import classNames from 'classnames';
import './index.less';

const FeaturedDesigners = ({
  title,
  stores,
}: {
  title: string;
  stores: {
    category: string;
    fullName: string;
    imageUrl: string;
    instagram: string;
    storeHandle: string;
    isPrimary?: boolean;
  }[];
}) => {
  const { screenSize, isMobile } = useConfigProvider();

  const SamplePrevArrow = ({ slideCount, currentSlide, ...props }: any) => (
    <div {...props} data-slide-count={slideCount} data-current-slide={currentSlide}>
      <ArrowLeftOutlined />
    </div>
  );

  const SampleNextArrow = ({ slideCount, currentSlide, ...props }: any) => (
    <div {...props} data-slide-count={slideCount} data-current-slide={currentSlide}>
      <ArrowRightOutlined />
    </div>
  );

  const getSlidesToShow = useMemo((): number => {
    if (screenSize?.width > 768) {
      return 4;
    }
    return 2;
  }, [screenSize?.width]);

  const sliderSettings = {
    slidesToShow: getSlidesToShow,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    draggable: false,
    arrows: true,
    autoPlay: true,
    classNames: 'carousel',
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  return (
    <div className="featured-designers">
      <Divider className="title">{title}</Divider>
      <div className="inner">
        <Carousel {...sliderSettings}>
          {stores.map((item, i) => (
            <div className="carousel-item" key={`carousel-item-${i}`}>
              <Link
                href={`/s/${item.storeHandle}`}
                onClick={() => {
                  logCommonView(EventSource.SHOP_ALL_FEATURED, item.storeHandle);
                }}
              >
                <div
                  className="featured-creator"
                  style={{
                    backgroundImage: `linear-gradient(to top, rgba(0, 0, 0, 0.6) 15%, transparent 60%), url(${imgix(
                      item.imageUrl,
                      { h: isMobile ? 250 : 400, dpr: 2, q: 75 },
                    )})`,
                    height: isMobile ? 250 : 400,
                    marginBottom: isMobile ? '2rem' : '0',
                  }}
                >
                  <div
                    className={classNames('overlay', {
                      'primary-feature': item.isPrimary,
                    })}
                  >
                    <div className="title">Shop Collection</div>
                    <p className="description">
                      Show your support by shopping {item.fullName}&apos;s products.
                    </p>
                    <button className="go-to-shop">Click to Shop</button>
                  </div>
                  <div
                    className={classNames('content', {
                      'primary-feature': item.isPrimary,
                    })}
                  >
                    {item.isPrimary && <p className="featured">Featured</p>}
                    <p className="title">{item.fullName}</p>
                    <div className="information">
                      <p className="category">{item.category}</p>
                      <p className="instagram">
                        {item.instagram.split(',').map((insta) => (
                          <span className="instagram-item" key={insta}>
                            @{insta}
                            <span className="and">&amp;</span>
                          </span>
                        ))}
                      </p>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </Carousel>
        <div className="button-container">
          <Link
            className="action-button utility-big"
            href={'/s'}
            onClick={() => {
              logCommonView(EventSource.SHOP_ALL_FEATURED, 'BROWSE_ALL');
            }}
          >
            Browse All Creator Shops
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FeaturedDesigners;
